var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: _vm.pram.id ? "编辑商品频道" : "新增商品频道",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "pram", attrs: { "label-width": "120px", model: _vm.pram } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "频道名称：",
                    prop: "channelName",
                    rules: [
                      {
                        required: true,
                        message: "请填写频道名称",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.pram.channelName,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "channelName", $$v)
                      },
                      expression: "pram.channelName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "频道状态：",
                    prop: "status",
                    rules: [
                      {
                        required: true,
                        message: "请选择状态",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.pram.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "status", $$v)
                        },
                        expression: "pram.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("启用"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("禁用"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "开启线下支付",
                    prop: "isOfflinePayment",
                    rules: [
                      {
                        required: true,
                        message: "请选择是否开启线下支付",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.pram.isOfflinePayment,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "isOfflinePayment", $$v)
                        },
                        expression: "pram.isOfflinePayment",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("开启"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("关闭"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", [_vm._v("开启后，该频道福豆可用于线下支付")]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注：", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      resize: "none",
                      placeholder: "请输入",
                    },
                    model: {
                      value: _vm.pram.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "remark", $$v)
                      },
                      expression: "pram.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.handerSubmit("pram")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }